import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  EntityWithMeta,
  TarlV3Jsonapi,
  convertEntityToJsonapiBody,
  getDeserialisedDatumOrOriginalEntityWithMeta,
} from '®shared/tarl-v3-jsonapi';

import { Review } from './review';

@Injectable()
export class ReviewService {
  constructor(private tarlV3JsonApi: TarlV3Jsonapi) {}

  /**
   * @param {string} listId - The reading list ID
   * @return {Observable<EntityWithMeta<Review>>} - The created review
   */
  createReview(listId: string): Observable<EntityWithMeta<Review>> {
    const path = this.tarlV3JsonApi.path('/reviews', {});
    const review = new Review();
    review.list = { id: listId, type: 'lists' };
    const topLevel = convertEntityToJsonapiBody(review);

    return this.tarlV3JsonApi
      .postRawJsonapiResponse(path, topLevel)
      .pipe(map(getDeserialisedDatumOrOriginalEntityWithMeta(review)));
  }

  /**
   * @param {string} listId - The reading list ID
   * @return {Observable<Review[]>} - The review history
   */
  getReviewHistory(listId: string): Observable<Review[]> {
    const path = this.tarlV3JsonApi.path('/lists/{listId}/reviews_history', {
      listId,
    });
    const query = { include: ['requested_by', 'started_by', 'completed_by'] };
    return this.tarlV3JsonApi.getResources<Review>(path, query);
  }
}
